import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Communication } from '../../services/communications.service';

@Component({
    selector: 'app-create-communication-dialog',
    templateUrl: './create-communication-dialog.component.html',
    styleUrls: ['./create-communication-dialog.component.sass'],
    standalone: false
})
export class CreateCommunicationDialogComponent {
  form: UntypedFormGroup;

  constructor(
    private dialogRef: MatDialogRef<CreateCommunicationDialogComponent>,
    private fb: UntypedFormBuilder
  ) {
    this.form = this.fb.group({
      title: ['', [Validators.required, Validators.maxLength(100)]],
      body: ['', [Validators.required, Validators.maxLength(10000)]]
    });
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
